// extracted by mini-css-extract-plugin
module.exports = {"innerContent":"Accordion_innerContent__7p74Q","arrow":"Accordion_arrow__1y4jH","openDrawer":"Accordion_openDrawer__3Ft1f"};